import Preview from "./Preview";
import React from "react";
import { css } from '@emotion/core';
import padding from "../../Styles/padding";
import useChannelPreviews from "../hooks/useChannelPreviews";
import useRerenders from "../hooks/useRerenders";

let previewContainer = css`
  background: #fff;
  display: flex;
  justify-content: center;
`;

let previewsWrapper = css`
  padding: 0 ${padding.standard};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export default function Previews({ channels, current, previews, onClickPreview }) {

  // Rerender every 30 seconds
  useRerenders(30 * 1000);
  previews = useChannelPreviews(previews);

  let now = Math.floor(Date.now() / 1000);

  return <div css={previewContainer}>
    <div css={previewsWrapper} className={"inner-page-content"}>
      {
        channels.map(({ name }, index) => {
          if (typeof previews[name] !== 'undefined' && previews[name]) {
            let channelPreviews = previews[name].filter(([s, e, { end_date }]) => now <= end_date);

            if (channelPreviews.length > 0) {
              let [show, episode, airing, thumbnail] = channelPreviews[0];
              return <Preview
                key={name}
                active={current === index}
                channel={name}
                show={show.title}
                episode={episode.title}
                airing={airing}
                thumbnail={thumbnail}
                onClick={() => onClickPreview(index)}
                additionalAirings={channelPreviews.slice(1)}
              />;
            }
          }

          return <Preview
            key={name}
            active={current
            ===
            index}
            channel={name}
            thumbnail={null}
            onClick={() => onClickPreview(index)}
            additionalAirings={[]}
          />;
        })
      }
    </div>
  </div>;
}